import { createStore, applyMiddleware, compose } from 'redux'
import { syncHistory } from 'react-router-redux'
import promiseMiddleware from '../lib/promiseMiddleware'
import thunk from 'redux-thunk'
import rootReducer from 'reducers'

export default function configureStore(initialState, history) {
	
  const finalCreateStore = compose(
    applyMiddleware(thunk, promiseMiddleware, syncHistory(history)),
	)(createStore)

  return finalCreateStore(rootReducer, initialState)
}



/** WEBPACK FOOTER **
 ** ./stores/configureStore.prod.js
 **/